import Index from 'src/pages/Suppliers/Products/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/suppliers/:id/products',
    name: 'Produkte Lieferant',
    component: Index,
    meta: auth
  }
]
